module.exports = __webpack_public_path__ + "static/media/shield-4.d7251e33.glb";